<template>
    <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
    > 
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-on="on"
                v-bind="attrs"
                :value="formattedDate"
                :label="label"
                readonly
                append-icon="event"
                clearable
                @click:clear="resetVal()"
                :alvqa="alvqa + '-datepicker-filter-textfield'"
            ></v-text-field> 
        </template>
        <v-date-picker 
            v-model="date"
            :locale="this.$i18n.locale"
            color="buttonStandard"
            no-title
            :alvqa="alvqa + '-datepicker-filter-picker'"
        >
            <v-spacer></v-spacer>
            <BaseButton 
                class="text-center"
                label="lang_GENERAL_BUTTON_CANCEL"
                @click="cancel()"
                :alvqa="alvqa + '-button-cancel'"
            />
            <BaseButton 
                class="text-center"
                label="lang_GENERAL_BUTTON_OK"
                @click="$refs.menu.save(date)"
                :alvqa="alvqa + '-button-ok'"
            />
        </v-date-picker>
    </v-menu>
</template>

<script>
import BaseButton from '@/components/_buttons/BaseButton'

export default {
    name: "DatePickerFilter",
    props: {
        context: String,
        label: String,
        alvqa: String
    },
    components: {
        BaseButton
    },
    data() {
        return {
            menu: false
        }
    },
    computed: {
        formattedDate() {
            return this.date ? this.$d(new Date(this.date), 'alvDateFormat') : ''
        },
        date: {
            get() { return this.$store.getters['getSelected'+this.context] },
            set(newDate) { this.$store.commit('setSelected'+ this.context, newDate) }
        }
    },
    methods: {
        cancel() {
            this.menu = false
            this.resetVal()
        },
        async resetVal() {
            await this.$nextTick()
            this.date = null
        }
    }
}
</script>